import { camelCase, mapKeys, isNumber, round } from 'lodash'
import { MacroGoalsDaily } from '@src/screens/Settings/models/settings.types'
import { Macros } from './types'

export const DEFAULT_GOALS = {
  calories: 2000,
  protein: 75,
  carbs: 150,
  fat: 75,
  netCarbs: 110,
}

export const extractData = (
  nutritionData: Record<string, number | undefined>,
  nutritionGoals?: MacroGoalsDaily,
): { values: Macros; goals: Macros } => {
  const nutrition = mapKeys(nutritionData, (_, key) => camelCase(key))
  const carbs = round(nutrition.totalCarb ?? 0, 2)

  const values = {
    calories: round(nutrition.calories ?? 0, 2),
    protein: round(nutrition.protein ?? 0, 2),
    carbs,
    fat: round(nutrition.totalFat ?? 0, 2),
    netCarbs: Math.max(carbs - round(nutrition.fiber ?? 0, 2), 0),
  }

  let netCarbsGoal = round(nutritionGoals?.netCarbs || DEFAULT_GOALS.netCarbs, 2)
  const carbsGoal = round(nutritionGoals?.carbs || DEFAULT_GOALS.carbs, 2)
  if (carbsGoal < netCarbsGoal) {
    netCarbsGoal = carbsGoal
  }

  const goals = {
    calories: round(nutritionGoals?.calories || DEFAULT_GOALS.calories, 2),
    protein: round(nutritionGoals?.protein || DEFAULT_GOALS.protein, 2),
    carbs: carbsGoal,
    fat: round(nutritionGoals?.fat || DEFAULT_GOALS.fat, 2),
    netCarbs: netCarbsGoal,
  }

  return { values, goals }
}

export const scoreColor = (number: number, danger = 4, warning = 7) => {
  if (number <= danger) {
    return 'theme.range.bad'
  }
  if (number <= warning) {
    return 'theme.range.regular'
  }
  return 'theme.range.good'
}

export const formatScore = (score: number | null | undefined) =>
  isNumber(score) ? Math.round(score) : undefined
